import { useEffect } from "react";
import { useSelector } from "react-redux";
import { usePortal } from "../context/PortalContext";
import { applyPwaManifest } from "../utils/pwaManifest";
import { resolvePwaBranding } from "../utils/splashBranding";
import { isClinicPortal } from "../utils/portalHost";

export function usePwaManifestBranding(pathname) {
  const authTenant = useSelector((state) => state.auth.tenant);
  const features = useSelector((state) => state.auth.entitlements?.features);
  const { clinic } = usePortal();

  const tenant = authTenant?.id ? authTenant : clinic?.id ? clinic : null;

  useEffect(() => {
    if (!isClinicPortal()) {
      applyPwaManifest(pathname);
      return undefined;
    }

    const branding = tenant?.id
      ? resolvePwaBranding({ tenant, features })
      : null;

    applyPwaManifest(pathname, branding);

    return undefined;
  }, [
    pathname,
    tenant?.id,
    tenant?.name,
    tenant?.logo_url,
    tenant?.portal_accent_color,
    features?.splash_branding,
  ]);
}
